import {httpsCallable} from "@firebase/functions";
import {functions} from "../../firebase/FirebaseProvider";

export function updatePhotoDescription(photoId: string, description: string, onSuccess?: () => void): Promise<void> {
    const updatePhotoDescriptionFunc = httpsCallable(functions, 'updatePhotoDescription');
    return updatePhotoDescriptionFunc(
        {
            photoId: photoId,
            description: description.trim() || null
        }
    ).then(r => {
        if (onSuccess) {
            onSuccess();
        } else {
            window.location.assign(window.location.href);
        }
    });
}

export function hidePhoto(photoId: string, onSuccess?: () => void): Promise<void> {
    const hidePhotoFunc = httpsCallable(functions, 'hidePhoto');
    return hidePhotoFunc(
        {
            photoId
        }
    ).then(r => {
        if (onSuccess) {
            onSuccess();
        } else {
            window.location.assign('/hub/photos');
        }
    });
}

export function addPhotoTags(photoId: string, tags: Array<string>, onSuccess?: () => void): Promise<void> {
    const addPhotoTagsFunc = httpsCallable(functions, 'addPhotoTags');
    return addPhotoTagsFunc(
        {
            photoId: photoId,
            tags: tags
        }
    ).then(r => {
        if (onSuccess) {
            onSuccess();
        } else {
            window.location.assign(window.location.href);
        }
    });
}

export function clearPhotoTags(photoId: string, onSuccess?: () => void): Promise<void> {
    const clearPhotoTagsFunc = httpsCallable(functions, 'clearPhotoTags');
    return clearPhotoTagsFunc(
        {
            photoId: photoId,
            tags: []
        }
    ).then(r => {
        if (onSuccess) {
            onSuccess();
        } else {
            window.location.assign(window.location.href);
        }
    });
}

export function updatePhotoLocation(photoId: string, locationId: string, locationName: string, onSuccess?: () => void): Promise<void> {
    const updatePhotoLocationFunc = httpsCallable(functions, 'updatePhotoLocation');
    return updatePhotoLocationFunc(
        {
            photoId,
            locationId,
            locationName
        }
    ).then(r => {
        if (onSuccess) {
            onSuccess();
        } else {
            window.location.assign(window.location.href);
        }
    });
}
